<template>
  <div class="home py-3">
    <v-layout align-left class="em3-left">
      <v-switch
        id="klass-switch"
        class="mb-3 mt-0"
        @change="setKlassToAll"
        :label="
          showAllArticles ? 
          $store.state.user.langEng ? `Shows all articles` : `Visar alla artiklar` :
          $store.state.user.langEng ? `Shows ${$store.getters.classNameInUrl} articles` : `Visar ${$store.getters.classNameInUrl} artiklar`
        "
      ></v-switch>
    </v-layout>
    <div v-if="unpublishedArticles.length">
      <transition
        name="animate-route"
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <ul class="collapsible expandable z-depth-0">
          <li>
            <div class="collapsible-header">
              <h5 class="mb-3 ml-5 unpublished-text">
                {{
                  $store.state.user.langEng
                    ? "Unpublished articles"
                    : "Opublicerade artiklar"
                }}
              </h5>
              <span><i class="material-icons" style="opacity:0.5">play_arrow</i></span>
            </div>
            <div class="collapsible-body">
              <article-list
                :articles="unpublishedArticles"
                key="unpubs"
                :showKlasses="true"
                :showSnippet="showSnippet"
              />
            </div>
          </li>
        </ul>
      </transition>
      <h5 class="mt-5 mb-5 ml-5 published-text" style="text-align: start;">
        {{
          $store.state.user.langEng
            ? "Published articles"
            : "Publicerade artiklar"
        }}
      </h5>
    </div>
    <transition
      name="animate-route"
      mode="out-in"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <article-list
        :articles="articles"
        key="pubs"
        :showKlasses="true"
        :showSnippet="showSnippet"
      />
    </transition>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import ArticleList from "@/components/ArticleList/ArticleList";
import SearchArticles from "../components/SearchArticles";
import $ from "jquery";

@Component({
  components: {
    ArticleList,
  },
})
export default class AdminArticles extends Vue {
  unpublishedArticles = [];
  showAllArticles = true

  get showSnippet() {
    return this.$route.name == "createArticle";
  }

  get articles() {
    return this.$store.state.article.articles;
  }

  setKlassToAll(isChecked) {
    this.showAllArticles = isChecked

    isChecked
      ? this.$store.commit("setCurrentKlass", "")
      : this.$store.dispatch("resetKlassToInitial");
  }

  @Watch("$store.state.article.searchTerm")
  onSearchTermChange() {
    this.doThrottledSearch();
  }

  @Watch("$store.state.article.selectedCategories")
  onSelectedCategoriesChange() {
    this.doThrottledSearch();
  }

  @Watch("$store.state.currentKlass")
  watchCurrentKlass() {
    this.doThrottledSearch();
  }

  doThrottledSearch() {
    clearTimeout(this.doSearchTimeout);
    this.doSearchTimeout = setTimeout(() => {
      this.doNewSearch();
    }, 100);
  }

  activateCollapsible() {
    let elem = document.querySelector(".collapsible.expandable");
    this.$M.Collapsible.init(elem, {
      accordion: false,
    });
  }

  mounted() {
    this.doThrottledSearch();

    // Workaround Vuetify bug, v-switch v-model true DOES NOT WORK when changed dynamically.
    setTimeout(() => {
      $("#klass-switch").click();
    }, 0);
  }

  async doNewSearch() {
    let klass = this.$store.state.currentKlass;
    if (this.$route.name == "createArticle") {
      klass = this.$store.getters.classNameInUrl;
    }

    let query = [
      this.$store.state.search,
      this.$store.state.article.selectedCategories,
      0,
      klass,
      "admin",
    ];
    let res = await SearchArticles.getSearchedArticles(...query);
    this.unpublishedArticles = res;

    setTimeout(() => {
      this.activateCollapsible();
    }, 0);
  }

  // reset all articles to make a new fetch filtered on klass
  beforeDestroy() {
    !this.$store.state.currentKlass && this.$store.commit("resetSearch");
  }
}
</script>

<style scoped lang="scss">
.unpublished-text {
  font-weight: 700;
  font-family: "Libre Franklin";
  opacity: 0.5;
}
.published-text {
  font-weight: 700;
  font-family: "Libre Franklin";
}
.em3-left {
  padding-left: 1.2em;
}
.collapsible.expandable {
  border: none;
  padding: 0;
  .collapsible-header {
    align-items: center;
    background: #fcfcfc;
    border-bottom: none;
    display: flex;
    justify-content: space-between !important;
    padding: 0;
    i {
      font-size: 2em;
      transition-duration: 0.3s;
    }
  }
  .collapsible-body {
    color: gray;
    padding: 0;
  }
  li.active {
    i {
      color: gray;
      transform: rotate(90deg);
    }
  }
}
</style>
